import { render, staticRenderFns } from "./Hzms.vue?vue&type=template&id=52f2e01e&scoped=true&"
import script from "./Hzms.vue?vue&type=script&lang=js&"
export * from "./Hzms.vue?vue&type=script&lang=js&"
import style0 from "./Hzms.vue?vue&type=style&index=0&id=52f2e01e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2e01e",
  null
  
)

export default component.exports